import React, { useState, useEffect } from 'react';
import Container from '../../Container/Container';
import { post, get, put } from '../../ApiServices/ApiServices';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router';
import DeleteButton from '../Component/DeleteFun';

function ExportsData() {
    const [interval, setInterval] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [Allemail, setAllemail] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalMode, setModalMode] = useState('create');
    const [currentEmail, setCurrentEmail] = useState({ id: '', email: '', is_active: true });
    const [modalSubmitting, setModalSubmitting] = useState(false);

    const options = [
        { label: '15 minutes', value: 15 },
        { label: '30 minutes', value: 30 },
        { label: '45 minutes', value: 45 },
        { label: '1 hour', value: 60 },
        { label: '1 hour 15 minutes', value: 75 },
        { label: '1 hour 30 minutes', value: 90 },
        { label: '1 hour 45 minutes', value: 105 },
        { label: '2 hours', value: 120 }
    ];

    const navigate = useNavigate();

    const fetchInterval = async () => {
        try {
            const response = await get('get-setting?setting_for=Export Interval');
            if (response?.status === true && response?.data?.value) {
                setInterval(response.data.value);
            }
        } catch (error) {
            toast.error('Failed to load current interval');
        }
    };

    const fetchEmail = async () => {
        try {
            const response = await get('all-notification-emails');
            if (response?.status == true) {
                setAllemail(response?.data?.rows);
            }
        } catch (error) {
            toast.error('Failed to load emails');
        }
    };

    useEffect(() => {
        fetchEmail();
        fetchInterval();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!interval) {
            toast.error("Please select an interval");
            return;
        }

        try {
            setIsSubmitting(true);
            const response = await post('set-setting', {
                setting_for: 'Export Interval',
                intervalInMinutes: interval
            });

            if (response?.status === true) {
                toast.success('Export interval set successfully');
            } else {
                toast.error(response?.message || 'Failed to set interval');
            }
        } catch (error) {
            toast.error('Something went wrong');
        } finally {
            setIsSubmitting(false);
        }
    };

    const openCreateModal = () => {
        setCurrentEmail({ id: '', email: '', is_active: true });
        setModalMode('create');
        setShowModal(true);
    };

    const openEditModal = (email) => {
        setCurrentEmail({
            id: email.id,
            email: email.email,
            is_active: email.is_active
        });
        setModalMode('edit');
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleModalSubmit = async (e) => {
        e.preventDefault();

        if (!currentEmail.email) {
            toast.error("Please enter an email address");
            return;
        }

        try {
            setModalSubmitting(true);
            let response;

            if (modalMode === 'create') {
                response = await post('create-notification-email', {
                    email: currentEmail.email,
                    is_active: currentEmail.is_active
                });
            } else {
                response = await post(`edit-notification-email/${currentEmail.id}`, {
                    email: currentEmail.email,
                    is_active: currentEmail.is_active
                });
            }

            if (response?.status === true) {
                toast.success(`Email ${modalMode === 'create' ? 'added' : 'updated'} successfully`);
                fetchEmail();
                closeModal();
            } else {
                toast.error(response?.message || `Failed to ${modalMode === 'create' ? 'add' : 'update'} email`);
            }
        } catch (error) {
            toast.error('Something went wrong');
        } finally {
            setModalSubmitting(false);
        }
    };

    return (
        <Container>
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">Set Export Interval</h3>
                                    </div>
                                    <div className="nk-block-head-content">
                                        <button
                                            className="btn btn-primary"
                                            onClick={openCreateModal}
                                        >
                                            Add Email
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="card card-full">
                                <div className="card-inner">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label className="form-label">Choose Interval</label>
                                                <select
                                                    className="form-control"
                                                    value={interval}
                                                    onChange={(e) => setInterval(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Select Interval</option>
                                                    {options.map((opt, idx) => (
                                                        <option key={idx} value={opt.value}>
                                                            {opt.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-12">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary"
                                                    disabled={isSubmitting}
                                                >
                                                    {isSubmitting ? 'Submitting...' : 'Set Interval'}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div className="card card-full mt-4">
                                <div className="card-header">
                                    <h5 className="card-title">Notification Emails</h5>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Email</th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Allemail.length > 0 ? Allemail.map((data) => {
                                                    return (
                                                        <tr key={data.id}>
                                                            <td>{data?.email}</td>
                                                            <td>
                                                                <span className={`badge ${data?.is_active ? 'bg-success' : 'bg-danger'}`}>
                                                                    {data?.is_active ? 'Active' : 'Inactive'}
                                                                </span>
                                                            </td>
                                                            <td className="tableActionBtn">
                                                                <a className="editPen" style={{ cursor: "pointer" }} onClick={() => openEditModal(data)}>
                                                                    <em className="icon ni ni-edit-alt"></em>
                                                                </a>
                                                                {/* <span className="deleteTrash" style={{ cursor: "pointer" }} onClick={() => { navigate(`/affiliated-detail`, { state: { id: data?.id } }) }}>
                                                                    <em className="icon ni ni-eye"></em>
                                                                </span> */}
                                                                <DeleteButton url={`delete-notification-email/${data?.id}`} onDeleteSuccess={fetchEmail} />
                                                            </td>
                                                        </tr>
                                                    )
                                                }) : (
                                                    <tr>
                                                        <td colSpan={"3"} className="text-center">
                                                            <div className="data-not-found">
                                                                <em className="icon ni ni-info"></em>
                                                                <p>No email addresses found</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {/* Modal for Create/Edit Email */}
                            {showModal && (
                                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">
                                                    {modalMode === 'create' ? 'Add Notification Email' : 'Edit Notification Email'}
                                                </h5>
                                                <button type="button" className="close" onClick={closeModal}>
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <form onSubmit={handleModalSubmit}>
                                                <div className="modal-body">
                                                    <div className="form-group">
                                                        <label className="form-label">Email Address</label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            placeholder="Enter email address"
                                                            value={currentEmail.email}
                                                            onChange={(e) => setCurrentEmail({ ...currentEmail, email: e.target.value })}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="form-label">Status</label>
                                                        <div className="toggle-container">
                                                            <label className="toggle-switch">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={currentEmail.is_active}
                                                                    onChange={(e) => setCurrentEmail({ ...currentEmail, is_active: e.target.checked })}
                                                                />
                                                                <span className="toggle-slider"></span>
                                                            </label>
                                                            <span className="toggle-label">
                                                                {currentEmail.is_active ? 'Active' : 'Inactive'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-secondary" onClick={closeModal}>
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary"
                                                        disabled={modalSubmitting}
                                                    >
                                                        {modalSubmitting ? 'Saving...' : (modalMode === 'create' ? 'Add Email' : 'Update Email')}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <style jsx>{`
                                .toggle-container {
                                    display: flex;
                                    align-items: center;
                                    gap: 10px;
                                }
                                
                                .toggle-switch {
                                    position: relative;
                                    display: inline-block;
                                    width: 60px;
                                    height: 30px;
                                }
                                
                                .toggle-switch input {
                                    opacity: 0;
                                    width: 0;
                                    height: 0;
                                }
                                
                                .toggle-slider {
                                    position: absolute;
                                    cursor: pointer;
                                    top: 0;
                                    left: 0;
                                    right: 0;
                                    bottom: 0;
                                    background-color: #ccc;
                                    transition: .4s;
                                    border-radius: 34px;
                                }
                                
                                .toggle-slider:before {
                                    position: absolute;
                                    content: "";
                                    height: 22px;
                                    width: 22px;
                                    left: 4px;
                                    bottom: 4px;
                                    background-color: white;
                                    transition: .4s;
                                    border-radius: 50%;
                                }
                                
                                input:checked + .toggle-slider {
                                    background-color: #2196F3;
                                }
                                
                                input:checked + .toggle-slider:before {
                                    transform: translateX(30px);
                                }
                                
                                .toggle-label {
                                    font-weight: 500;
                                }
                            `}</style>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default ExportsData;